import UserEvent from "../types/UserEvent";
import getDateKey from "../utils/getDateKey";

export default async function getUserEvents(
  date: Date,
  userId: string
): Promise<UserEvent[] | null> {
  const dateKey = getDateKey(date);
  const storedUserEvents = localStorage.getItem(
    `${dateKey}-${userId}-userEvents`
  );
  if (!storedUserEvents) return null;

  try {
    const events = JSON.parse(storedUserEvents) as {
      title: string;
      date: string;
    }[];
    return events.map(
      (event) => new UserEvent(event.title, new Date(event.date))
    );
  } catch (e) {
    console.error(e);
    return null;
  }
}
